import { ComponentProps } from 'react';
import './style.scss';
import AntdButton from 'antd/es/button';

export default function Button(props: ComponentProps<typeof AntdButton>) {
    return <AntdButton size="large" {...props} />;
}
